export const makeStack = <T>() => {
  const stack: T[] = []

  const push = (item: T) => {
    stack.unshift(item)
  }

  const pop = (predicate?: (item: T) => boolean): T | undefined => {
    const index = predicate ? stack.findIndex(predicate) : 0
    if (index >= 0) {
      const item = stack[index]
      stack.splice(index, 1)
      return item
    }
    return undefined
  }

  return { push, pop }
}
